import React, { useEffect, useState } from "react";
import { convertReactIconToUrl } from "./util";
import { GoogleMap } from "@react-google-maps/api";
import { mapContainerStyle, mapOptions, searchOptionsModal } from "./data";
import MarkerInfoModal from "./MarkerModal";
import Select from "react-select";
import PatientList from "./PatientList";
import { useFetchPatientPrimaryLocationMutation } from "../../features/patient/patientApiSlice";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";

const RightBar = ({
  setMap,
  selectedLocation,
  setSelectedLocation,
  onCLickZoomToMarker,
  locations,
  center,
  selectedProviders,
  selectedPatients,
  selectedZones,
  locationsLoading,
}) => {
  const [isMapLoaded, setIsMapLoaded] = useState(false);

  const handleMapLoad = (map) => {
    setIsMapLoaded(true);
    setMap(map);
  };

  const [search, setSearch] = useState("");
  const [searchOption, setSearchOption] = useState(searchOptionsModal[0]);

  const handleSearchOption = (option) => {
    setSearchOption(option);
  };

  useEffect(() => {
    if (selectedLocation == null) {
      setSearch("");
    }
  }, [selectedLocation]);

  const [selectedLocationPatients, setSelectedLocationPatients] =
    React.useState([]);

  const [fetchPatientPrimaryLocation, { isLoading }] =
    useFetchPatientPrimaryLocationMutation();

  const fetchProviderPatients = async () => {
    setSelectedLocationPatients([]);

    const { data } = await fetchPatientPrimaryLocation({
      id: selectedLocation.id,
      body: {
        type: selectedLocation.type,
        providerIds: selectedProviders.map((provider) => provider.value),
        patientIds: selectedPatients.map((patient) => patient.value),
        zoneIds: selectedZones.map((zone) => zone.value),
      },
    }).unwrap();

    setSelectedLocationPatients(data);
  };

  useEffect(() => {
    if (selectedLocation && selectedLocation.type !== "PROVIDER_HOME")
      fetchProviderPatients();
  }, [selectedLocation]);

  return (
    <div className="flex-1 w-9/12 p-6 overflow-hidden h-[calc(100vh-146px)]">
      <div className="relative border border-black rounded-md overflow-clip">
        {(locationsLoading || !isMapLoaded) && (
          <div className="absolute top-0 w-full z-[999]">
            <Box sx={{ width: "100%" }}>
              <LinearProgress
                sx={{ height: "6px" }}
                style={{
                  color: "#3062D4",
                  background: "#8fadf3",
                }}
              />
            </Box>
          </div>
        )}
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          center={center}
          zoom={6}
          options={mapOptions}
          onLoad={handleMapLoad}
        />
        <div className="absolute flex flex-col gap-2 p-2 text-sm bg-white rounded-md shadow-md bottom-4 left-4">
          <div className="flex items-center gap-2">
            <img
              src={convertReactIconToUrl("COMMUNITY_HOME", "#000000")}
              alt="Community"
              width={20}
              height={20}
            />
            <span className="font-semibold">Community</span>
          </div>
          <div className="flex items-center gap-2 mt-1">
            <img
              src={convertReactIconToUrl("PRIVATE_HOME", "#000000")}
              alt="Private Home"
              width={20}
              height={20}
            />
            <span className="font-semibold">Private Home</span>
          </div>
          <div className="flex items-center gap-2 mt-1">
            <img
              src={convertReactIconToUrl("PROVIDER_HOME", "#000000")}
              alt="Private Home"
              width={20}
              height={20}
            />
            <span className="font-semibold">Provider Home</span>
          </div>
        </div>
      </div>
      <MarkerInfoModal
        isOpen={!!selectedLocation && selectedLocation != null}
        onClose={() => setSelectedLocation(null)}
        location={selectedLocation}
      >
        <div className="flex flex-col w-full gap-2 pb-3 border-b">
          <input
            type="text"
            placeholder={`Search By ${searchOption.label}...`}
            className="p-2 border rounded-md"
            onChange={(value) => {
              setSearch(value.target.value);
            }}
          />
          <Select
            defaultValue={searchOption}
            name="colors"
            isDisabled={isLoading}
            isLoading={isLoading}
            options={searchOptionsModal}
            classNamePrefix="select"
            className="basic-multi-select w-full overflow-visible h-9 z-[1000]"
            menuPortalTarget={document.body}
            onChange={handleSearchOption}
            styles={{
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999,
              }),
            }}
          />
        </div>
        <PatientList
          patients={selectedLocationPatients.filter((patient) =>
            searchOption === searchOptionsModal[0]
              ? patient.name.toLowerCase().includes(search.toLowerCase())
              : patient.provider.toLowerCase().includes(search.toLowerCase())
          )}
          selectedPatient={null}
          handlePatient={() => {}}
          locations={locations}
          isModal={true}
          onCLickZoomToMarker={onCLickZoomToMarker}
        />
      </MarkerInfoModal>
    </div>
  );
};

export default RightBar;
